import type { PluginObject } from 'vue';

import Confirm from './components/Confirm.vue';

async function confirm(message: string): Promise<boolean> {
  const div = document.createElement('div');
  document.body.append(div);
  const instance = new Confirm({
    propsData: { message },
  }).$mount(div) as InstanceType<typeof Confirm>;
  try {
    return await instance.confirm();
  } finally {
    instance.$destroy();
  }
}

const ConfirmPlugin: PluginObject<never> = {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$confirm = confirm;
  },
};

export default ConfirmPlugin;
